// Created by Claude Code AI Agent
// Multi-region: the login response carries the user's region code (LoginResult.Region),
// which CurrentUserService spreads into the persisted CurrentUser. Resolve the regional
// API base URL by looking that code up in environment.regions. Falls back to
// environment.apiUrl / apiBetaUrl when no region is set — preserves single-region
// behavior and pre-login requests (the login call itself goes to the default URL).

import { Injectable } from '@angular/core';
import { CurrentUserService } from '@smartmoving/sm-shared-lib';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RegionService {
  constructor(private readonly currentUserService: CurrentUserService) {}

  getRegion(): string | null {
    return this.currentUserService.instance?.region ?? null;
  }

  getApiBaseUrl(): string {
    return this.resolveRegionalUrl(environment.apiUrl);
  }

  getApiBetaBaseUrl(): string {
    return this.resolveRegionalUrl(environment.apiBetaUrl);
  }

  private resolveRegionalUrl(fallback: string): string {
    const region = this.getRegion();
    const regions = (environment as { regions?: Record<string, string> }).regions;
    if (region && regions && regions[region]) {
      return regions[region];
    }
    return fallback;
  }
}
